import * as React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Divider from '@mui/material/Divider';
import DownloadIcon from '@mui/icons-material/Download';
import Drawer from '@mui/material/Drawer';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
// import CloudRoundedIcon from '@mui/icons-material/CloudRounded';
import HomeRepairServiceRoundedIcon from '@mui/icons-material/HomeRepairServiceRounded';
import SaveIcon from '@mui/icons-material/Save';
import Toolbar from '@mui/material/Toolbar';
import UploadIcon from '@mui/icons-material/Upload';

import * as WrcCommon from '@webrcade/app-common';
//i18n
import { useI18n } from '../i18n/I18nContext';

import { Global, GlobalHolder } from '../Global';
import CommonTooltip from './common/CommonTooltip';
import * as Feed from '../Feed';
import NewMenu from './NewMenu';
// import CloudMenu from './CloudMenu';
import ToolsMenu from './ToolsMenu';
import Prefs from '../Prefs';



function EditorDrawer(props) {
  const { drawerWidth } = props;

  const { t } = useI18n(); // hook de tradução

  const [open, setOpen] = React.useState(false);
  const [newMenuAnchor, setNewMenuAnchor] = React.useState(false);
  // const [cloudMenuAnchor, setCloudMenuAnchor] = React.useState(false);
  const [toolsMenuAnchor, setToolsMenuAnchor] = React.useState(false);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  GlobalHolder.toggleDrawer = toggleDrawer;

  const drawer = (
    <div>
      <Toolbar />
      <List>
        <ListItem
          button
          key="new"
          onClick={(e) => {
            if (WrcCommon.config.isPublicServer()) {
              setNewMenuAnchor(e.target);
            } else {
              const feed = Feed.newFeed();
              Global.setFeed({ ...feed });
              setOpen(false);
            }
          }}
        >
          <ListItemIcon><NoteAddIcon /></ListItemIcon>
          {/* 🔹 "New" → traduzido */}
          <ListItemText primary={t('editorDrawerNew')} />
        </ListItem>
      </List>
      <Divider />
      <List>
        <CommonTooltip
          // 🔹 "Import a feed from a URL or local file."
          title={t('editorDrawerImportTooltip')}
        >
          <ListItem
            button
            key="import"
            onClick={(e) => {
              setOpen(false);
              Global.openImportDialog(true);
            }}
          >
            <ListItemIcon><UploadIcon /></ListItemIcon>
            {/* 🔹 "Import" */}
            <ListItemText primary={t('editorDrawerImport')} />
          </ListItem>
        </CommonTooltip>
        <CommonTooltip
          // 🔹 "Export and download the feed."
          title={t('editorDrawerExportTooltip')}
        >
          <ListItem
            button
            key="export"
            onClick={() => {
              setOpen(false);
              Global.openExportDialog(true);
            }}
          >
            <ListItemIcon><DownloadIcon /></ListItemIcon>
            {/* 🔹 "Export" */}
            <ListItemText primary={t('editorDrawerExport')} />
          </ListItem>
        </CommonTooltip>
      </List>
      <Divider />
      <List>
        <CommonTooltip
          // 🔹 "Test the feed in the Meu Retrô Box front-end."
          title={t('editorDrawerTestTooltip')}
        >
          <ListItem
            button
            key="test"
            onClick={() => {
              // The window is opened outside async to support iOS
              const newWindow = window.open();
              newWindow.document.write('<html><body style="background-color:black;"></body></html>');
              (async () => {
                setOpen(false);

                // Store the test feed
                await Prefs.storeTestFeed(GlobalHolder.getFeed());

                // Open webrcade
                let url = (WrcCommon.isDev()
                  ? WrcCommon.config.getLocalUrl()
                  : '../../');
                url += `?${WrcCommon.AppProps.RP_EDITOR_TEST}=${WrcCommon.AppProps.RV_EDITOR_TEST_ENABLED}`;
                newWindow.location = url;
              })();
            }}
          >
            <ListItemIcon><CheckCircleIcon /></ListItemIcon>
            {/* 🔹 "Test" */}
            <ListItemText primary={t('editorDrawerTest')} />
          </ListItem>
        </CommonTooltip>
      </List>
      <Divider />
      <List>
        <CommonTooltip
          // 🔹 "Load feed."
          title={t('editorDrawerLoadTooltip')}
        >
          <ListItem
            button
            key="load"
            onClick={() => {
              setOpen(false);
              Global.openLoadFeedDialog(true);
            }}
          >
            <ListItemIcon><FileOpenIcon /></ListItemIcon>
            {/* 🔹 "Load" */}
            <ListItemText primary={t('editorDrawerLoad')} />
          </ListItem>
        </CommonTooltip>
        <CommonTooltip
          // 🔹 "Save the feed locally."
          title={t('editorDrawerSaveTooltip')}
        >
          <ListItem
            button
            key="save"
            onClick={async () => {
              setOpen(false);
              const feeds = await WrcCommon.loadFeeds(0);
              const feed = Global.getFeed();
              const existing = feeds.isExistingLocalFeed(feed.title);

              const f = async () => {
                let succeeded = false;
                // 🔹 "Saving feed..."
                Global.openBusyScreen(true, t('msgSavingFeed'));
                try {
                  if (await feeds.addLocalFeed(Feed.exportFeed(feed))) {
                    succeeded = true;
                  }
                } catch (e) {
                  WrcCommon.LOG.error('Error saving feed: ' + e);
                } finally {
                  Global.openBusyScreen(false);
                }
                if (succeeded) {
                  // 🔹 "Succesfully saved feed."
                  Global.displayMessage(t('msgFeedSavedSuccess'), 'success');
                } else {
                  // 🔹 "Error saving feed."
                  Global.displayMessage(t('msgFeedSavedError'), 'error');
                }
              };

              if (existing) {
                Global.openConfirmDialog(
                  true,
                  // 🔹 "Save Feed"
                  t('dialogSaveFeedTitle'),
                  // 🔹 "Continue and overwrite the existing feed?"
                  t('dialogSaveFeedOverwriteMessage'),
                  f
                );
              } else {
                f();
              }
            }}
          >
            <ListItemIcon><SaveIcon /></ListItemIcon>
            {/* 🔹 "Save" */}
            <ListItemText primary={t('editorDrawerSave')} />
          </ListItem>
        </CommonTooltip>
      </List>
      <Divider />
      <List>
        <ListItem
          button
          key="tools"
          onClick={(e) => {
            setToolsMenuAnchor(e.target);
          }}
        >
          <ListItemIcon><HomeRepairServiceRoundedIcon /></ListItemIcon>
          {/* 🔹 "Tools" */}
          <ListItemText primary={t('editorDrawerTools')} />
        </ListItem>
      </List>
      {/* <Divider /> */}
      {/* {WrcCommon.settings.isCloudStorageEnabled() &&
        <List>
          <ListItem button key="cloud" onClick={(e) => {
            setCloudMenuAnchor(e.target);
          }}>
            <ListItemIcon><CloudRoundedIcon /></ListItemIcon>
            <ListItemText primary="Cloud Storage" />
          </ListItem>
        </List>
      } */}
    </div>
  );

  return (
    <>
      <Drawer
        variant="temporary"
        open={open}
        onClose={toggleDrawer}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', sm: 'none', md: 'block' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
        open
      >
        {drawer}
      </Drawer>
      <NewMenu
        anchorEl={newMenuAnchor}
        setAnchorEl={setNewMenuAnchor}
        setOpen={setOpen}
      />
      {/* <CloudMenu
        anchorEl={cloudMenuAnchor}
        setAnchorEl={setCloudMenuAnchor}
        setOpen={setOpen}
      /> */}
      <ToolsMenu
        anchorEl={toolsMenuAnchor}
        setAnchorEl={setToolsMenuAnchor}
        setOpen={setOpen}
      />
    </>
  );
}

export default EditorDrawer;